import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Proposal} from './classes/second-tab.model';
import {AvailableCourier, AvailableCourierDates} from './classes/courier.model';
import {catchError, retry} from 'rxjs/operators';
import {ErrorObservable} from 'rxjs/observable/ErrorObservable';
import {AppConfig} from '../../../app.config';
import {AppLoadService} from '../../../app-load.service';
import {storageFactory} from '../../../app-storage';

@Injectable()
export class DataService {
  appConfig: AppConfig;

  constructor(private http: HttpClient, public appLoadService: AppLoadService) {
    this.appConfig = new AppConfig();
    this.checkToken();
  }

  checkToken() {
    if (localStorage == null) {
      this.appConfig.headers = this.appConfig.headers.set(
        'Authorization',
        'Bearer ' + document.getElementById('toktok').innerHTML
      );
    } else {
      let token = storageFactory(localStorage).getItem('token');
      if (token != 'undefined') {
        this.appConfig.headers = this.appConfig.headers.set(
          'Authorization',
          'Bearer ' + token
        );
      }
    }
  }

  getBrands(categoryId: number) {
    return this.http
      .get(this.appConfig.url + `Categories/${categoryId}/Brands`, {
        headers: this.appConfig.headers
      })
      .pipe(catchError(this.handleError));
  }

  getModels(brandId: number, categoryId: number, featureIds: string, isCashback: string) {
    return this.http
      .get(this.appConfig.url + `Brands/${brandId}/${categoryId}/${isCashback}/Products/Filter/${featureIds || ' '}/`, {
        headers: this.appConfig.headers
      })
      .pipe(catchError(this.handleError));
  }

  getCategoryFeatures(categoryId: number, brandId: number = null) {
    var url = this.appConfig.url + `Categories/${categoryId}/Features`;
    if (brandId) {
      url += `/${brandId}`;
    }
    return this.http
      .get(url, {
        headers: this.appConfig.headers
      })
      .pipe(catchError(this.handleError));
  }

  getQuestions(categoryId: number) {
    return this.http
      .get(this.appConfig.url + `Categories/${categoryId}/Questions`, {
        headers: this.appConfig.headers
      })
      .pipe(catchError(this.handleError));
  }

  getCities() {
    return this.http
      .get(this.appConfig.url + 'Cities', {headers: this.appConfig.headers})
      .pipe(catchError(this.handleError));
  }

  getDistricts(cityId: number) {
    return this.http
      .get(this.appConfig.url + `Cities/${cityId}/Districts`, {
        headers: this.appConfig.headers
      })
      .pipe(catchError(this.handleError));
  }

  getTowns(districtId: number) {
    return this.http
      .get(this.appConfig.url + `Cities/${districtId}/Towns`, {
        headers: this.appConfig.headers
      })
      .pipe(catchError(this.handleError));
  }

  getMerchantInfo(postedProposal: Proposal) {
    return this.http
      .post(this.appConfig.url + 'Proposals/GetPrice', postedProposal, {
        headers: this.appConfig.headers
      })
      .pipe(catchError(this.handleError));
  }

  getOrders(shopperId: string) {
    return this.http
      .get(this.appConfig.url + `Orders/shopperid?shopperid=${shopperId}`, {
        headers: this.appConfig.headers
      })
      .pipe(catchError(this.handleError));
  }

  postProposal(postedProposal: Proposal) {
    return this.http
      .post(this.appConfig.url + 'Proposals', postedProposal, {
        headers: this.appConfig.headers
      })
      .pipe(catchError(this.handleError));
  }

  getCategories() {
    return this.http
      .get(this.appConfig.url + 'Categories', {
        headers: this.appConfig.headers
      })
      .pipe(catchError(this.handleError));
  }

  getCategory(categoryId: number) {
    return this.http
      .get(this.appConfig.url + `Categories/${categoryId}`, {
        headers: this.appConfig.headers
      })
      .pipe(catchError(this.handleError));
  }

  getCategorySteps(categoryId: number) {
    return this.http
      .get(this.appConfig.url + `Categories/${categoryId}/Steps`, {
        headers: this.appConfig.headers
      })
      .pipe(catchError(this.handleError));
  }

  getPageContents(categoryId: number, query: string = '') {
    return this.http
      .get(this.appConfig.url + `Categories/${categoryId}/PageContent/${query}`, {
        headers: this.appConfig.headers
      })
      .pipe(catchError(this.handleError));
  }

  getCategoryUrls() {
    return this.http
      .get(this.appConfig.url + 'Categories/Urls', {
        headers: this.appConfig.headers
      })
      .pipe(catchError(this.handleError));
  }

  getDefaultCategory() {
    return this.http
      .get(this.appConfig.url + 'Categories/Default', {
        headers: this.appConfig.headers
      })
      .pipe(catchError(this.handleError));
  }

  searchProduct(id: number, categoryId: number, query: string, isCashback: string) {
    return this.http
      .get(
        this.appConfig.url +
        `Brands/${id}/${categoryId}/${isCashback}/Products/Search/${query}`,
        {headers: this.appConfig.headers}
      )
      .pipe(
        /* retry(3) , */
        catchError(this.handleError)
      );
  }

  getAvailableCourier(postedAvailableCourier: AvailableCourier) {
    return this.http
      .post(this.appConfig.url + 'claims/options', postedAvailableCourier, {
        headers: this.appConfig.headers
      })
      .pipe(catchError(this.handleError));
  }

  getAvailableCourierDates(postedAvailableCourierDates: AvailableCourierDates) {
    return this.http
      .post(this.appConfig.url + 'claims/availableDays', postedAvailableCourierDates, {
        headers: this.appConfig.headers
      })
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      if (error.status === 401) {
        if (localStorage == null) {
          this.appConfig.headers = this.appConfig.headers.set(
            'Authorization',
            'Bearer ' + document.getElementById('toktok').innerHTML
          );
        } else {
          this.appConfig.headers = this.appConfig.headers.set(
            'Authorization',
            'Bearer ' + storageFactory(localStorage).getItem('token')
          );
        }
        return new ErrorObservable('Geçersiz token');
      } else if (error.status === 0) {
        return new ErrorObservable('Beklenmedik bir hata oluştu.');
      }
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    return new ErrorObservable(
      'Something bad happened; please try again later.'
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/shared/data.service.ts